import { render, staticRenderFns } from "./SeverityTag.vue?vue&type=template&id=4cd0bd14&"
import script from "./SeverityTag.vue?vue&type=script&lang=js&"
export * from "./SeverityTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports